import { qsa } from "@fluorescent/dom";

import { section } from "@/glow";
import videoPlayerBlock from "@/lib/video-player-block";
import { animateStandard, shouldAnimate } from "@/lib/animation";

const selectors = {
  videoPlayerVideo: "[data-video-player-block-video]",
  videoPlayerBlock: ".video-player-block",
};

section("rich-text", {
  onLoad() {
    const videoPlayerVideos = qsa(selectors.videoPlayerVideo, this.container);

    if (videoPlayerVideos.length) {
      this.videoPlayers = videoPlayerVideos.map(block =>
        videoPlayerBlock(block.closest(selectors.videoPlayerBlock))
      );
    }

    if (shouldAnimate(this.container)) {
      this.animateRichText = animateStandard(this.container);
    }
  },

  onUnload() {
    this.videoPlayers && this.videoPlayers.forEach(button => button.unload());
    this.animateRichText?.destroy();
  },
});
